module.exports = __webpack_public_path__ + "static/img/Video.70ffa39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cutehub/imgs/browse/Video.jpg
// module id = 2319
// module chunks = 0